"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
const MultiplicityUtilities_1 = require("../../../../panels/extra/utilities/MultiplicityUtilities");
const editRangeFormValidation = Yup.object().shape({
    signals: Yup.array()
        .of(Yup.object().shape({
        js: Yup.array()
            .of(Yup.object().shape({
            multiplicity: Yup.string().required(),
            coupling: Yup.mixed().test('checkValue', '', function testCoupling(value) {
                const { path, createError } = this;
                const hasCoupling = (0, MultiplicityUtilities_1.hasCouplingConstant)(this.parent.multiplicity);
                if ((!hasCoupling && !value) || (hasCoupling && value)) {
                    return true;
                }
                return createError({
                    path,
                    message: `${path} is required`,
                });
            }),
        }))
            .min(1, 'There must be at least one coupling in a signal'),
    }))
        .min(1, 'There must be at least one signal in a range!'),
});
exports.default = editRangeFormValidation;
